import { Component, Input, input, InputSignal, output } from '@angular/core';
import { AlertComponent } from '../../../../../../../common/alert/alert.component';
import { LabelComponent } from '../../../../../../../common/label/label.component';
import { CommonModule } from '@angular/common';
import { ParcelAppEntityParcelWrite } from '../../../../../../../openapi';

@Component({
  selector: 'app-parcels-preview',
  standalone: true,
  imports: [
    AlertComponent,
    LabelComponent,
    CommonModule
  ],
  templateUrl: './parcels-preview.component.html'
})
export class ParcelsPreviewComponent {

  public showActions = input(false);

  public canEdit = input(true);

  @Input()
  public noDataInfo = 'Dodaj dane przynajmniej 1 działki!';

  public parcels: InputSignal<ParcelAppEntityParcelWrite[]> = input<ParcelAppEntityParcelWrite[]>([]);

  public onRemove = output<number>();

  public onEdit = output<{ v: ParcelAppEntityParcelWrite, i: number }>();

}
